import locale from "csi/locale";
import Delete from "csi/table/Delete";
import MessageDialog from "csi/widget/MessageDialog";
import declare from "dojo/_base/declare";

const DeleteThemeBOMPlacementController = declare(Delete, {

	/**
     * @override
	 * If there are StyleBOMs linked to ThemeBOM, make button unlink and delete
	 * 	when deleting placements.
	 * 		
     */
	confirmAction(params: any): void {
		const themeBOM = this.getCache()
			.getNode(this.getParent().__Parent__);
		if (themeBOM.ThemeBOMLinkedStyleBOMs.length) {
			params.materialIcon = MessageDialog.ICON_WARNING;
			params.title = locale.resource("UnlinkAndDeleteThemeBOMPlacement_Title");
			params.message = locale.resource("UnlinkAndDeleteThemeBOMPlacement_Confirm");
			this.m_action.confirmAction = MessageDialog.BUTTON_UNLINK_AND_DELETE;
		}

		this.inherited(arguments);
	},
});

export = DeleteThemeBOMPlacementController;